import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function PlanHeader({ onNewGoal }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "wrap",
        mb: 4,
      }}
    >
      <Box>
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: 34, md: 42 },
            fontWeight: 800,
            letterSpacing: 0,
            lineHeight: 1.02,
            mb: 0.75,
          }}
        >
          Your Plan
        </Typography>
        <Typography sx={{ fontSize: 16, color: "text.secondary" }}>
          Build a plan TrustBud can help you keep.
        </Typography>
      </Box>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onNewGoal}
        sx={{
          minHeight: 46,
          px: 2,
          borderRadius: "8px",
          boxShadow: "0 10px 18px rgba(23, 52, 93, 0.14)",
        }}
      >
        Add goal
      </Button>
    </Box>
  );
}
